import { Component, OnInit, Input } from '@angular/core'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { CheckoutService } from '../../checkout.service'
import { ActiveCartFacade } from '@spartacus/cart/base/root'

@Component({
  standalone: false,
  selector: 'vs-address-detail',
  templateUrl: './address-detail.component.html',
  styleUrls: ['./address-detail.component.scss'],
})
export class AddressDetailComponent implements OnInit {
  public billToAdd
  public shipToadd
  public endCustAdd

  public cartOrderReviewObj: any
  cartId: any

  constructor(
    private checkoutService: CheckoutService,
    public activeCartService: ActiveCartFacade,
    private globalMessageService: GlobalMessageService
  ) {
    this.activeCartService.getActiveCartId().subscribe(
      (success) => {
        this.cartId = success
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  ngOnInit(): void {
    this.checkoutService.addressObjData.subscribe(
      (data) => {
        this.cartOrderReviewObj = data
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
}
